import React from 'react';

// size: 'sm' | 'md' | 'lg'
// color: 'blue' | 'white' | 'gray'
const LoadingSpinner = ({
  message = 'Loading...',
  inline = false,
  size = 'md',
  color = 'blue',
  showMessage = true,
  className = '',
}) => {
  const sizeClass = size === 'sm' ? 'h-4 w-4' : size === 'lg' ? 'h-12 w-12' : 'h-8 w-8';
  const colorClass = color === 'white' ? 'border-white' : color === 'gray' ? 'border-gray-500' : 'border-blue-500';

  if (inline) {
    return (
      <div
        className={`animate-spin rounded-full ${sizeClass} border-b-2 ${colorClass} ${className}`}
        aria-hidden="true"
      />
    );
  }

  return (
    <div className="flex flex-col items-center justify-center p-4">
      <div className={`animate-spin rounded-full ${sizeClass} border-b-2 ${colorClass} mb-2`} />
      {showMessage && (
        <p className="text-gray-600 dark:text-gray-300 text-sm">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;